import * as ui from '../../ui/index.js';

/**
 * Loader for the Sidebar module
 * 
 * @author rhess <robin.hess@awi.de>
 * @author sjaswal <shahzeib.jaswal@awi.de> 
 */

/**
 * A function that loads the Sidebar
 * 
 * @memberof vef.viewer.loader
 * 
 * @param {object} options 
 * @param {Viewer} viewer 
 */
export function Sidebar(options, viewer) {
    const sidebar = new ui.sidebar.Sidebar(null, options);

    if (options.groups) {
        for (let i = 0; i < options.groups.length; ++i) {
            const group = options.groups[i];
            sidebar.addGroup(group.id, group.title, group.classes);
            if (group.active) sidebar.show(group.id);

            viewer.addElement(group.id, sidebar.getGroupContainer(group.id));
        }
    }

    viewer.addElement(options.id, sidebar);
}
